import { PaymentActionResult } from '../paymentModal/checkout/types';

export interface IAppleGoogleViewModel {
  getStripeKey: () => Promise<string>;
  processPaymentCancel: () => Promise<void>;
  processPaymentError: (error: any) => Promise<void>;
  processPaymentAction: (paymentMethodId: string, email: string, stripePlanId: string, internalId: string, productAmount?: string, productName?: string, paymentSystem?: string, answers?: any, showChatUpsale?: boolean) => Promise<PaymentActionResult>;
}

export enum PAYMENT_SYSTEM {
  APPLE_PAY = 'applePay',
  GOOGLE_PAY = 'googlePay',
  BROWSER_SAVED_CARD = 'Browser-saved cards',
}
